import { useGateway } from '@civic/gateway-client-react';
export const useICPGateway = () => {
    const { gatewayToken } = useGateway();
    const icpGatewayToken = gatewayToken
        ? {
            gatekeeperNetworkAddress: gatewayToken.gatekeeperNetworkAddress,
            owner: gatewayToken.owner,
            state: gatewayToken.state,
            identifier: gatewayToken.identifier,
            expiryTime: gatewayToken.expiryTime,
        }
        : undefined;
    return Object.assign(Object.assign({}, useGateway()), { gatewayToken: icpGatewayToken });
};
